// 화면 수명에 묶인 읽기 요청 취소 신호.
//
// 페이지가 바뀌었는데 이전 페이지의 목록·상세 조회가 계속 돌면 새 화면 요청과 DB 통로를
// 함께 차지한다. 경로가 바뀌는 순간 이전 신호를 abort 하고 새 신호를 발급해, 공통 API
// 클라이언트를 타는 GET/HEAD 요청을 한꺼번에 정리한다. 저장·삭제·전송은 이 신호를 쓰지 않는다.

let pathname = "";
let controller = new AbortController();

export function enterRouteRequestScope(nextPathname: string): boolean {
  if (nextPathname === pathname) return false;
  const previous = controller;
  pathname = nextPathname;
  controller = new AbortController();
  previous.abort(new DOMException("화면 이동으로 더 이상 필요하지 않은 조회를 취소했습니다.", "AbortError"));
  return true;
}

export function getRouteRequestSignal(): AbortSignal {
  return controller.signal;
}

/** 테스트에서 모듈 전역 상태를 독립시키기 위한 진입점. 운영 코드에서는 쓰지 않는다. */
export function resetRouteRequestScopeForTest(): void {
  pathname = "";
  controller = new AbortController();
}
